import { render, staticRenderFns } from "./PageTasks.vue?vue&type=template&id=87e5a848&"
import script from "./PageTasks.vue?vue&type=script&lang=ts&"
export * from "./PageTasks.vue?vue&type=script&lang=ts&"
import style0 from "./PageTasks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VDataTable,VIcon,VSelect,VSpacer,VTab,VTimePicker})
